import { Abstrap } from '../..';

const { propTypes } = Abstrap;

const defaultProps = { ...Abstrap.defaultProps, componentClass: 'div' };

class BlockPadding extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-block__padding',
            className,
        ];
    }

}

BlockPadding.propTypes = propTypes;

BlockPadding.defaultProps = defaultProps;

export default BlockPadding;
